module.exports = __webpack_public_path__ + "img/wait.5c48248b.png";